import {
  ChannelAssignId,
  ChannelId,
  CompactChannelResponse,
  SupportChannelAssginRequest,
  SupportChannelAssginResponse,
  SupportChannelRequest,
  SupportChannelResponse,
} from '@business/entities/SupportChannel';
import { ChannelRuleId, SupportChannelRuleRequest, SupportChannelRuleResponse } from '@business/entities/SupportChannel/SupportChannelRuleResponse';
import { Endpoint } from '../endpoint';
import { ChannelEmailVerifyRequest } from './../../entities/SupportChannel/SupportChannelAssginResponse';
import { SMTPFormData } from '@modules/settings/SettingsPage/Components/SupportTab/ChannelTab/ChannelEmailTab/EmailSettingsModal/EmailSettingsModal';

/**
 * Support Channel API
 */
export function fetchChannels() {
  return Endpoint.get<SupportChannelResponse[] | CompactChannelResponse[]>(`@gc/support-channel`);
}

export function fetchDetailChannels() {
  return Endpoint.get<SupportChannelResponse[]>(`@gc/support-channel?isDetail=true`);
}
export function fetchChannel(id: ChannelId) {
  return Endpoint.get<SupportChannelResponse>(`@gc/support-channel/${id}`);
}
export function createChannel(data: SupportChannelRequest) {
  return Endpoint.post<SupportChannelResponse>(`@gc/support-channel`, { data: { ...data } });
}
export function updateChannel(id: ChannelId, data: SupportChannelRequest) {
  return Endpoint.patch<SupportChannelResponse>(`@gc/support-channel/${id}`, { data: { ...data } });
}
export function deleteChannel(id: ChannelId) {
  return Endpoint.delete<void>(`@gc/support-channel/${id}`);
}

/**
 * Support Channel Rules API
 */

export function fetchChannelRules(channelId: ChannelId) {
  return Endpoint.get<SupportChannelRuleResponse[]>(`@gc/support-channel/rules/${channelId}`);
}

export function createChannelRule(channelId: ChannelId, data: SupportChannelRuleRequest) {
  return Endpoint.post<SupportChannelRuleResponse>(`@gc/support-channel/rule/${channelId}`, { data: { ...data } });
}
export function updateChannelRule(ruleId: ChannelRuleId, data: SupportChannelRuleRequest) {
  return Endpoint.patch<SupportChannelRuleResponse>(`@gc/support-channel/rule/${ruleId}`, { data: { ...data } });
}
export function deleteChannelRule(ruleId: ChannelRuleId) {
  return Endpoint.delete<void>(`@gc/support-channel/rule/${ruleId}`);
}

/**
 * Support Channel Assginemt API
 */

export function fetchChannelAssgins(channelId: ChannelId) {
  return Endpoint.get<SupportChannelAssginResponse[]>(`@gc/support-channel/assignments/${channelId}`);
}

export function fetchVerifiedEmails() {
  return Endpoint.get<SupportChannelAssginResponse[]>(`@gc/support-channel/verified-emails`);
}
export function makeDefault(assignId: ChannelAssignId) {
  return Endpoint.post<SupportChannelAssginResponse[]>(`@gc/support-channel/default-email/${assignId}`, { data: {} });
}

export function createChannelAssgin(channelId: ChannelId, data: SupportChannelAssginRequest) {
  return Endpoint.post<SupportChannelAssginResponse>(`@gc/support-channel/assignment/${channelId}`, { data: { ...data } });
}
export function updateChannelAssgin(assignId: ChannelAssignId, data: SupportChannelAssginRequest) {
  return Endpoint.patch<SupportChannelAssginResponse>(`@gc/support-channel/assignment/${assignId}`, { data: { ...data } });
}
export function fetchChannelAssgin(assignId: ChannelAssignId) {
  return Endpoint.get<SupportChannelAssginResponse>(`@gc/support-channel/assignment/${assignId}`);
}
export function deleteChannelAssgin(assignId: ChannelAssignId) {
  return Endpoint.delete<void>(`@gc/support-channel/assignment/${assignId}`);
}

export function validateDomain(assignId: ChannelAssignId, data?: ChannelEmailVerifyRequest) {
  return Endpoint.post<SupportChannelAssginResponse>(`@gc/support-channel/validate-domain/${assignId}`, { data: { ...data } });
}

export function configureSMTP(assignId: ChannelAssignId, data: SMTPFormData) {
  return Endpoint.post<SupportChannelAssginResponse>(`@gc/support-channel/configure-smtp/${assignId}`, { data: { ...data } });
}

export function createDomain(assignId: ChannelAssignId) {
  return Endpoint.post<SupportChannelAssginResponse>(`@gc/support-channel/create-domain/${assignId}`);
}

export function sortChannels(ids: ChannelId[]) {
  return Endpoint.post<SupportChannelResponse[]>(`@gc/support-channel/sort`, { data: { ids } });
}
